import styled from "@emotion/styled";
import type { ComponentProps } from "react";

import { useFieldContext } from "../../FormFieldContext";
import { FieldText } from "../FieldText";
import { useFieldLabelAndDescription } from "../helpers";
import { FieldContainer, FieldDescription } from "./shared";

export const StyledFieldText = styled(FieldText)`
  .MuiInput-root {
    background: ${({ theme }) => theme.surfaceVariant};
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 4px 4px 0 0;
  }
`;

export const LandingPageFieldText = (props: ComponentProps<typeof FieldText>) => {
  const { name } = useFieldContext();
  const [description, tooltip] = useFieldLabelAndDescription(name);

  return (
    <FieldContainer>
      <FieldDescription description={description} tooltip={tooltip} disabled={!!props.disabled} />
      <StyledFieldText {...props} hideLabel hideHelperText />
    </FieldContainer>
  );
};
